export default function Terms() {
  return (
    <div className="page">
      <h2>Terms & Conditions</h2>
      <p>
        By using Scaffolders Education, you agree to our course usage rules,
        certification process, and payment policies.
      </p>
    </div>
  );
}
